import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5590f9d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-menu hidden-print" }
const _hoisted_2 = { class: "container d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "top-menu-impersonate" }
const _hoisted_4 = { class: "top-menu-nav" }
const _hoisted_5 = { class: "top-menu-items" }
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = {
  ref: "mainMenu",
  class: "main-menu hidden-print"
}
const _hoisted_8 = { class: "container" }
const _hoisted_9 = {
  key: 0,
  class: "main-menu-logo"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "46.45",
  width: "253.08"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#main-logo" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "main-menu-logo-mobile"
}
const _hoisted_14 = { class: "main-menu-nav" }
const _hoisted_15 = { class: "main-menu-nav-items" }
const _hoisted_16 = ["href", "title"]
const _hoisted_17 = { class: "main-menu-icons" }
const _hoisted_18 = {
  key: 0,
  class: "container"
}
const _hoisted_19 = {
  key: 0,
  class: "usp-bar w-100 hidden-print"
}
const _hoisted_20 = { class: "container d-flex" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "usp-text-small" }
const _hoisted_23 = { class: "usp-text-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImpersonationForm = _resolveComponent("ImpersonationForm")!
  const _component_MainSearchBar = _resolveComponent("MainSearchBar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers_text = _resolveComponent("font-awesome-layers-text")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_Message = _resolveComponent("Message")!
  const _component_MainUserMenu = _resolveComponent("MainUserMenu")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ChangeCompanyModal = _resolveComponent("ChangeCompanyModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.layoutStore.isImpersonated && _ctx.layoutStore.canImpersonate)
            ? (_openBlock(), _createBlock(_component_ImpersonationForm, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutStore.vm.subMenuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem,
                class: ""
              }, [
                _createElementVNode("a", {
                  href: menuItem.url,
                  title: menuItem.title
                }, _toDisplayString(menuItem.label), 9, _hoisted_6)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.isLargeScreen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.layoutStore.vm.homePageUrl
              }, _hoisted_12, 8, _hoisted_10)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _withDirectives(_createElementVNode("img", {
                style: {"cursor":"pointer"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openUrl(_ctx.layoutStore.vm.homePageUrl)))
              }, null, 512), [
                [_directive_lazy, '/Static/images/cadacgroup-logo-mobile.svg']
              ])
            ])),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutStore.vm.mainMenuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem,
                class: ""
              }, [
                _createElementVNode("a", {
                  href: menuItem.url,
                  title: menuItem.title
                }, _toDisplayString(menuItem.label), 9, _hoisted_16)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["main-menu-search", { searchActive: _ctx.layoutStore.showSearchBar }])
          }, [
            _createVNode(_component_MainSearchBar, {
              vm: _ctx.layoutStore.vm
            }, null, 8, ["vm"])
          ], 2),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_font_awesome_icon, {
              class: _normalizeClass({ 'text-primary': _ctx.layoutStore.showSearchBar }),
              icon: ['far', 'magnifying-glass'],
              title: _ctx.$t('menu.button.search_title'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggleSearchClick()))
            }, null, 8, ["class", "title"]),
            (_ctx.layoutStore.vm.itemsInCart)
              ? (_openBlock(), _createBlock(_component_font_awesome_layers, {
                  key: 0,
                  class: "fa-fw fa-2x",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCartClick()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'cart-shopping'],
                      title: _ctx.$t('menu.button.cart_title')
                    }, null, 8, ["title"]),
                    _createVNode(_component_font_awesome_layers_text, {
                      class: "fa-layers-counter",
                      transform: "up-1 right-15",
                      value: _ctx.layoutStore.vm.itemsInCart
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: ['far', 'cart-shopping'],
                  title: _ctx.$t('menu.button.cartEmpty_title'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCartClick()))
                }, null, 8, ["title"])),
            _createVNode(_component_font_awesome_icon, {
              class: _normalizeClass({ 'text-info': _ctx.layoutStore.isImpersonated }),
              icon: 
							_ctx.layoutStore.isImpersonated
								? ['far', 'user-shield']
								: _ctx.layoutStore.isAuthenticated
									? ['fas', 'circle-user']
									: ['far', 'circle-user']
						,
              title: _ctx.$t('menu.button.userMenu_title'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onToggleUserMenuClick($event)))
            }, null, 8, ["class", "icon", "title"]),
            _createVNode(_component_LanguageDropdown, {
              languages: _ctx.layoutStore.vm.availableLanguageOptions,
              title: _ctx.$t('menu.chooseLanguage_title'),
              "update-cookie": ""
            }, null, 8, ["languages", "title"])
          ])
        ])
      ]),
      (_ctx.layoutStore.isImpersonated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_Message, {
              class: "m-0 w-100 message-with-button",
              closable: false,
              severity: "info"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_i18n_t, { keypath: "menu.loggedInAsCustomer" }, {
                    user: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.layoutStore.vm?.impersonatedUser?.userName), 1),
                        _createTextVNode(" " + _toDisplayString(`- ${_ctx.layoutStore.vm?.impersonatedUser?.company?.companyName} (${_ctx.layoutStore.vm?.impersonatedUser?.company?.cadacOrganizationCode})`), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (!_ctx.layoutStore.vm?.impersonatedUser?.isEmailVerified)
                    ? (_openBlock(), _createBlock(_component_InlineMessage, {
                        key: 0,
                        severity: "warn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("menu.unverifiedEmail")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_ImpersonationForm)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (
			_ctx.layoutStore.vm.uspBlock.items &&
			_ctx.layoutStore.vm.uspBlock.items.length &&
			_ctx.layoutStore.vm.uspBlock.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutStore.vm.uspBlock.items, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  (item.uspCollectionLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.uspCollectionLink.url
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "usp-icon",
                          icon: item.uspIcon
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(item.uspCollectionTitle) + " ", 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.uspSubText), 1)
                      ], 8, _hoisted_21))
                    : _createCommentVNode("", true),
                  (!item.uspCollectionLink)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "usp-icon",
                          icon: item.uspIcon
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(item.uspCollectionTitle) + " ", 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(item.uspSubText), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      ref: "userMenuPanel",
      "append-to": ".main-menu",
      breakpoints: { '1400px': '250px' },
      class: "main-menu-overlay",
      dismissable: true,
      "show-close-icon": false,
      style: { width: '300px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MainUserMenu)
      ]),
      _: 1
    }, 512),
    (_ctx.layoutStore.changeCompanyModalVisible)
      ? (_openBlock(), _createBlock(_component_ChangeCompanyModal, {
          key: 1,
          vm: _ctx.layoutStore.vm.organizationOptions
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}